// extracted by mini-css-extract-plugin
export default {"ictoField":"ictofield_ictoField__DfH13","error":"ictofield_error__Av2lT","ictoText":"ictofield_ictoText__Ys8VW","textfield":"ictofield_textfield__oYslM"};